import React, { useEffect, useState } from "react";
import { personalInfo, section } from "../../../content/css/customCss";
import headerImage from "../../../content/css/img/printHeader.png";
import moment from "moment";

const PrintMarkRafiqExNotification = ({ printData, printType, calledFrom }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    if (!imageLoaded) {
      const img = new Image();
      img.src = headerImage;
      img.onload = () => setImageLoaded(true);
    }
  }, [imageLoaded]);

  const containerStyle = {
    width: "100%",
    top: calledFrom === "notifications" ? -200 : 0,
    background: "#fff",
    color: "#000",
  };

  const Check = ({ show }) => {
    return (
      <>
        <input
          type="checkbox"
          name="status"
          value="notCompleted"
          checked={show}
          style={{
            marginRight: "5px",
            appearance: "none",
            width: "15px",
            height: "15px",
            textAlign: "center",
            backgroundColor: "white",
            border: "1px solid grey",
            borderRadius: "3px",
            cursor: "pointer",
            display: "inline-block",
            position: "relative",
          }}
        />
        {show && (
          <span
            style={{
              position: "relative",
              left: "13px",
              fontSize: "12px",
              fontWeight: "bold",
              color: "black",
            }}
          >
            ✔
          </span>
        )}
      </>
    );
  };

  return (
    <>
      {printType === 4 ? (
        <div id="section-to-print" style={containerStyle} className="print">
          {/* Header Section */}
          <div style={{ position: "relative", textAlign: "center" }}>
            <img
              src={headerImage}
              alt="Tanzeem Islami Header"
              style={{ maxWidth: "100%" }}
            />
            {/* Overlay Text */}
            <h4
              className="ur header-text"
              style={{
                position: "absolute",
                top: "18%", // Adjust as needed
                right: "50%",
                transform: "translate(-50%, -50%)",
                color: "black", // Change color based on image background
                backgroundColor: "transparent", // Optional for better visibility
                padding: "10px",
                borderRadius: "5px",
              }}
            >
              مقامی تنظیم : {printData.MuqamiTanzeemName}{" "}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; حلقہ :{" "}
              {printData.HalqaName}
            </h4>
          </div>
          <div
            className="ur"
            style={{ direction: "rtl", marginTop: "-20px", wordSpacing: 2 }}
          >
            <h2 className="text-center">
              <u>
                رفیق کی "تنظیم سے{" "}
                {printData.MarkAsExReason?.split(":")[0]} قبول" کی سفارش
              </u>
            </h2>
            <h4
              className="m-3"
              style={{ fontSize: 20, marginRight: 40, marginLeft: 40 }}
            >
              <u>مقامی تنظیم کی سطح پر </u>
            </h4>
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      width: "10%",
                      fontSize: "15px",
                    }}
                  >
                    نام
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      width: "60%",
                      textAlign: "center",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.MemberName !== null &&
                    printData.MemberName !== ""
                      ? printData.MemberName
                      : "-"}
                  </span>
                </p>{" "}
              </div>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "0px",
                      display: "inline-block",
                      width: "10%",
                      fontSize: "15px",
                    }}
                  >
                    ولدیت
                  </span>
                  <span
                    style={{
                      marginRight: "10px",
                      display: "inline-block",
                      width: "60%",
                      textAlign: "center",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.MemberFatherName !== null &&
                    printData.MemberFatherName !== ""
                      ? printData.MemberFatherName
                      : "-"}
                  </span>
                </p>{" "}
              </div>
              <div style={section}>
                {" "}
                <p>
                  <span
                    className="ur"
                    style={{
                      marginRight: "-30px",
                      display: "inline-block",
                      width: "25%",
                      fontSize: "15px",
                    }}
                  >
                    رجسٹریشن نمبر
                  </span>
                  <span
                    style={{
                      marginLeft: "20px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "60%",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.MemberRegNo !== null &&
                    printData.MemberRegNo !== ""
                      ? printData.MemberRegNo
                      : "-"}
                  </span>
                </p>{" "}
              </div>
            </div>
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      width: "25%",
                      fontSize: "15px",
                    }}
                  >
                    تاریخ شمولیت
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      width: "40%",
                      textAlign: "center",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.JoiningDate !== null &&
                    printData.JoiningDate !== ""
                      ? printData.JoiningDate
                      : "-"}
                  </span>
                </p>{" "}
              </div>
              <div style={section}>
                {" "}
                <p>
                  <span
                    className="ur"
                    style={{
                      marginRight: "-25px",
                      display: "inline-block",
                      width: "80%",
                      fontSize: "15px",
                    }}
                  >
                    کس کی دعوت پر تنظیم اسلامی میں شمولیت اختیار کی
                  </span>
                  <span
                    style={{
                      marginRight: "-35px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "20%",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.JoinedOnWhoseInvitation !== null &&
                    printData.JoinedOnWhoseInvitation !== ""
                      ? printData.JoinedOnWhoseInvitation
                      : "-"}
                  </span>
                </p>{" "}
              </div>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "-20px",
                      display: "inline-block",
                      width: "50%",
                      fontSize: "15px",
                    }}
                  >
                    تعارفی اجتماع میں شرکت کی تاریخ
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      width: "25%",
                      textAlign: "center",
                      borderBottom: "1px dotted black",
                      fontSize: "14px",
                    }}
                  >
                    {printData.TarafiIjtimaAttendingDate !== null &&
                    printData.TarafiIjtimaAttendingDate !== ""
                      ? printData.TarafiIjtimaAttendingDate
                      : "-"}
                  </span>
                </p>{" "}
              </div>
            </div>
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      width: "45%",
                      fontSize: "15px",
                    }}
                  >
                    رفیق کی تعارفی اجتماع میں شرکت کی تاریخ
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      width: "30%",
                      textAlign: "center",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.TarafiIjtimaAttendingDate !== null &&
                    printData.TarafiIjtimaAttendingDate !== ""
                      ? printData.TarafiIjtimaAttendingDate
                      : "-"}
                  </span>
                </p>{" "}
              </div>
              <div style={section}>
                {" "}
                <p>
                  <span
                    className="ur"
                    style={{
                      marginRight: "30px",
                      display: "inline-block",
                      width: "35%",
                      fontSize: "15px",
                    }}
                  >
                    فہم دین کورس میں شرکت کی تاریخ
                  </span>
                  <span
                    style={{
                      marginLeft: "20px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "30%",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.FehmDeenAttendingDate !== null &&
                    printData.FehmDeenAttendingDate !== ""
                      ? printData.FehmDeenAttendingDate
                      : "-"}
                  </span>
                </p>{" "}
              </div>
            </div>
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      width: "55%",
                      fontSize: "15px",
                    }}
                  >
                    مبتدی/ملتزم کورس میں اگر شرکت کی ہے تو {"  "} تاریخ
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      width: "25%",
                      textAlign: "center",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.MubtadiMultazimCourseAttendingDate !== null &&
                    printData.MubtadiMultazimCourseAttendingDate !== ""
                      ? printData.MubtadiMultazimCourseAttendingDate
                      : "-"}
                  </span>
                </p>{" "}
              </div>
              <div style={section}>
                {" "}
                <p>
                  <span
                    className="ur"
                    style={{
                      marginRight: "10px",
                      display: "inline-block",
                      width: "15%",
                      fontSize: "15px",
                    }}
                  >
                    مقام
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                      width: "55%",
                      borderBottom: "1px dotted black",
                      fontSize: "13px",
                    }}
                  >
                    {printData.MubtadiMultazimCourseAttendingLocation !==
                      null &&
                    printData.MubtadiMultazimCourseAttendingLocation !== ""
                      ? printData.MubtadiMultazimCourseAttendingLocation
                      : "-"}
                  </span>
                </p>{" "}
              </div>
            </div>
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      width: "55%",
                      fontSize: "15px",
                    }}
                  >
                    کیا متعلقہ رفیق تنظیم میں شمولیت کے بعد ہی سے غیر فعال رہے
                    یا پہلے کسی دور میں وہ فعال بھی تھے
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      width: "25%",
                      textAlign: "center",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.WasMemberActiveBefore !== null &&
                    printData.WasMemberActiveBefore !== ""
                      ? printData.WasMemberActiveBefore
                      : "-"}
                  </span>
                </p>{" "}
              </div>
            </div>{" "}
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      width: "40%",
                      fontSize: "15px",
                    }}
                  >
                    اگر رفیق مسلسل غیر فعال رہے تو اس کی بنیادی وجوہات کیا محسوس
                    کی گئیں
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      width: "40%",
                      textAlign: "center",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.MemberInactivityReasons !== null &&
                    printData.MemberInactivityReasons !== ""
                      ? printData.MemberInactivityReasons
                      : "-"}
                  </span>
                </p>{" "}
              </div>
            </div>{" "}
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      width: "55%",
                      fontSize: "15px",
                    }}
                  >
                    کیا رفیق کو شمولیت کے وقت کسی اسره میں شامل کیا گیا
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      width: "25%",
                      textAlign: "center",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.MemberIncludedInAnyUsra !== null &&
                    printData.MemberIncludedInAnyUsra !== ""
                      ? printData.MemberIncludedInAnyUsra
                      : "-"}
                  </span>
                </p>{" "}
              </div>
              <div style={section}>
                {" "}
                <p>
                  <span
                    className="ur"
                    style={{
                      marginRight: "30px",
                      display: "inline-block",
                      width: "40%",
                      fontSize: "15px",
                    }}
                  >
                    رفیق نے آخری مرتبہ انفاق کب جمع کرایا
                  </span>
                  <span
                    style={{
                      marginLeft: "20px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "25%",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.LastFundDate !== null &&
                    printData.LastFundDate !== ""
                      ? printData.LastFundDate
                      : "-"}
                  </span>
                </p>{" "}
              </div>
            </div>
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      width: "55%",
                      fontSize: "15px",
                    }}
                  >
                    رفیق کی طرف سے نظم سے آخری بار رابطہ کب ہوا؟
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      width: "25%",
                      textAlign: "center",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.LastMemberContactWithUnit !== null &&
                    printData.LastMemberContactWithUnit !== ""
                      ? printData.LastMemberContactWithUnit
                      : "-"}
                  </span>
                </p>{" "}
              </div>
              <div style={section}>
                {" "}
                <p>
                  <span
                    className="ur"
                    style={{
                      marginRight: "30px",
                      display: "inline-block",
                      width: "45%",
                      fontSize: "15px",
                    }}
                  >
                    نظم نے رفیق سے آخری بار کب رابطہ کیا؟
                  </span>
                  <span
                    style={{
                      marginLeft: "20px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "25%",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.LastContactWithMemberByUnit !== null &&
                    printData.LastContactWithMemberByUnit !== ""
                      ? printData.LastContactWithMemberByUnit
                      : "-"}
                  </span>
                </p>{" "}
              </div>
            </div>{" "}
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      width: "50%",
                      fontSize: "15px",
                    }}
                  >
                    رفیق کا موجودہ پوسٹل ایڈریس اور شمولیت کے وقت کے ایڈریس میں
                    کوئی تبدیلی واقع ہوئی
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      width: "30%",
                      textAlign: "center",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.IsPostalAddressChangedAfterJoining !== null &&
                    printData.IsPostalAddressChangedAfterJoining !== ""
                      ? printData.IsPostalAddressChangedAfterJoining
                      : "-"}
                  </span>
                </p>{" "}
              </div>
            </div>{" "}
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      width: "30%",
                      fontSize: "15px",
                    }}
                  >
                    رفیق کا موجودہ رابطہ (پوسٹل ایڈریس و فون نمبر وغیرہ )
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      width: "50%",
                      textAlign: "center",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.MemberCurrentContactDetails !== null &&
                    printData.MemberCurrentContactDetails !== ""
                      ? printData.MemberCurrentContactDetails
                      : "-"}
                  </span>
                </p>{" "}
              </div>
            </div>{" "}
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      width: "80%",
                      fontSize: "15px",
                    }}
                  >
                    مقامی نظم کی جانب ہے جو متعلقہ رفیق سے ملاقات کی گئی اس میں
                    کیا محسوس کیا گیا
                  </span>
                </p>{" "}
              </div>
              <div style={section}>
                <div
                  style={{
                    marginRight: "-45px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    fontSize: "15px",
                    padding: "5px",
                  }}
                >
                  <label
                    style={{
                      marginRight: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Check
                      show={
                        printData.WhatReasonToLeftFeltOnMeetingMemberConflictOfInterest
                      }
                    />
                    <span style={{ marginRight: "5px" }}>فکری نا مختگی</span>
                  </label>

                  <label
                    style={{
                      display: "flex",
                      marginRight: "10px",
                      alignItems: "center",
                    }}
                  >
                    <Check
                      show={printData.WhatReasonToLeftFeltOnMeetingMemberBusy}
                    />
                    <span style={{ marginRight: "5px" }}>مصروفیت</span>
                  </label>
                  <label
                    style={{
                      display: "flex",
                      marginRight: "10px",
                      alignItems: "center",
                    }}
                  >
                    <Check
                      show={
                        printData.WhatReasonToLeftFeltOnMeetingMemberPressureFromHome
                      }
                    />
                    <span style={{ marginRight: "5px" }}>کھریلو دباؤ</span>
                  </label>
                  <label
                    style={{
                      display: "flex",
                      marginRight: "10px",
                      alignItems: "center",
                    }}
                  >
                    <Check
                      show={
                        printData.WhatReasonToLeftFeltOnMeetingMemberFinancialProblem
                      }
                    />
                    <span style={{ marginRight: "5px" }}>معاشی حالات</span>
                  </label>
                </div>
              </div>
            </div>{" "}
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      width: "10%",
                      fontSize: "15px",
                    }}
                  >
                    یا دیگر {"  "}
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                      width: "70%",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.WhatReasonToLeftFeltOnMeetingMemberOther !==
                      null &&
                    printData.WhatReasonToLeftFeltOnMeetingMemberOther !== ""
                      ? printData.WhatReasonToLeftFeltOnMeetingMemberOther
                      : "-"}
                  </span>
                </p>
              </div>
            </div>
            <div style={personalInfo}>
              <div style={section}>
                <div
                  style={{
                    marginRight: "-45px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    fontSize: "15px",
                    padding: "5px",
                  }}
                >
                  <label
                    style={{
                      marginRight: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Check show={printData.RequestFromUnitForExit} />
                    <span style={{ marginRight: "5px" }}>
                      نظم کی جانب سے اخراج کی سفارش{" "}
                    </span>
                  </label>

                  <label
                    style={{
                      display: "flex",
                      marginRight: "10px",
                      alignItems: "center",
                    }}
                  >
                    <Check show={printData.RequestFromMemberPersonally} />
                    <span style={{ marginRight: "5px" }}>
                      رفیق نے ازخود معذرت کی ہے.
                    </span>
                  </label>

                  <label
                    style={{
                      display: "flex",
                      marginRight: "10px",
                      alignItems: "center",
                    }}
                  >
                    <Check show={printData.RequestFromMemberInWrittenForm} />
                    <span style={{ marginRight: "5px" }}>
                      کیا رفیق نے معذرت تحریری طور پر کی ہے (کاپی منسلک کر لیں ){" "}
                    </span>
                  </label>
                </div>
              </div>
            </div>{" "}
            <br></br>
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      fontWeight: "bold",
                      width: "25%",
                      fontSize: "16px",
                    }}
                  >
                    مقامی امیر تنظیم
                  </span>
                </p>
              </div>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "-135px",
                      display: "inline-block",
                      width: "20%",
                      fontWeight: "bold",
                      fontSize: "15px",
                    }}
                  >
                    نام
                  </span>
                  <span
                    style={{
                      marginRight: "10px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "50%",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.MuqamiAmeerName !== null &&
                    printData.MuqamiAmeerName !== ""
                      ? printData.MuqamiAmeerName
                      : "-"}
                  </span>
                </p>
              </div>{" "}
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "-100px",
                      display: "inline-block",
                      width: "20%",
                      fontWeight: "bold",
                      fontSize: "15px",
                    }}
                  >
                    تاریخ
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                      width: "50%",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.DateOfRequest !== null &&
                    printData.DateOfRequest !== ""
                      ? moment(printData.DateOfRequest).format("DD/MM/yyyy")
                      : "-"}
                  </span>
                </p>
              </div>
            </div>{" "}
            <h4
              className="m-3"
              style={{ fontSize: 18, marginRight: 40, marginLeft: 40 }}
            >
              <u> حلقہ کی سطح پر </u>
            </h4>
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      width: "65%",
                      fontSize: "16px",
                    }}
                  >
                    مقامی امیر نے متعلقہ رفیق تنظیم سے{" "}
                    {printData.MarkAsExReason?.split(":")[0]} کے جو احوال
                    بتائے ہیں آپ ان سے مطمئن ہیں، تفصیل سے آگاہ فرمائیں{" "}
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                      width: "20%",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  ></span>
                </p>
              </div>
            </div>
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "80%",
                      borderBottom: "1px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.AmeerHalqaFeedback !== null &&
                    printData.AmeerHalqaFeedback !== ""
                      ? printData.AmeerHalqaFeedback
                      : "-"}
                  </span>
                </p>
              </div>
            </div>{" "}
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      fontWeight: "bold",
                      width: "25%",
                      fontSize: "16px",
                    }}
                  >
                    امیر حلقہ
                  </span>
                </p>
              </div>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "-135px",
                      display: "inline-block",
                      width: "20%",
                      fontWeight: "bold",
                      fontSize: "15px",
                    }}
                  >
                    نام
                  </span>
                  <span
                    style={{
                      marginRight: "10px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "50%",
                      borderBottom: "2px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.AmeerHalqaName !== null &&
                    printData.AmeerHalqaName !== ""
                      ? printData.AmeerHalqaName
                      : "-"}
                  </span>
                </p>
              </div>{" "}
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "-100px",
                      display: "inline-block",
                      width: "20%",
                      fontWeight: "bold",
                      fontSize: "15px",
                    }}
                  >
                    تاریخ
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                      width: "50%",
                      borderBottom: "2px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.DateOfRequest !== null &&
                    printData.DateOfRequest !== ""
                      ? moment(printData.DateOfRequest).format("DD/MM/yyyy")
                      : "-"}
                  </span>
                </p>
              </div>
            </div>{" "}
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      fontWeight: "bold",
                      width: "25%",
                      fontSize: "18px",
                    }}
                  >
                    <u>تصدیق نامہ</u>
                  </span>
                </p>
              </div>
            </div>{" "}
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      width: "80%",
                      fontSize: "16px",
                    }}
                  >
                    تصدیق کی جاتی ہے کے محترم جناب{" "}
                    <u style={{ fontSize: 17, fontWeight: "bold" }}>
                      {printData.MemberName ? printData.MemberName : ""}
                    </u>{" "}
                    سے تنظیمی نظم نے رابطہ کی ہر ممکن کوشش کی اور حلقہ کی سطح پر
                    اس ضمن میں بھرپور معاونت رہی لیکن یہ تمام کوششیں بے سود
                    رہیں. بنا بریں سفارش کی جاتی ہے کے موصوف کے{" "}
                    <u style={{ fontSize: 17, fontWeight: "bold" }}>
                      تنظیم سے {printData.MarkAsExReason?.split(":")[0]}{" "}
                    </u>{" "}
                    کے لئے کروائی کو اگے بڑھایا جائے{" "}
                  </span>
                </p>
              </div>
            </div>{" "}
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "480px",
                      display: "inline-block",
                      width: "10%",
                      fontWeight: "bold",
                      fontSize: "15px",
                    }}
                  >
                    نائب نظم اعلی
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                      width: "20%",
                      borderBottom: "2px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.NaibNazimAllaName !== null &&
                    printData.NaibNazimAllaName !== ""
                      ? printData.NaibNazimAllaName
                      : "-"}
                  </span>
                </p>
              </div>
            </div>
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "85%",
                      borderBottom: "1px solid black",
                      fontSize: "15px",
                    }}
                  ></span>
                </p>
              </div>
            </div>{" "}
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "40px",
                      display: "inline-block",
                      width: "60%",
                      fontWeight: "bold",
                      fontSize: "15px",
                    }}
                  >
                    اخراج کی سفارش کی صورت میں رفیق کو خط تحریر کرنے کی تاریخ
                  </span>
                  <span
                    style={{
                      marginRight: "10px",
                      display: "inline-block",
                      textAlign: "center",
                      width: "20%",
                      borderBottom: "2px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.WrittenLetterSentToRafiqDate !== null &&
                    printData.WrittenLetterSentToRafiqDate !== ""
                      ? printData.WrittenLetterSentToRafiqDate
                      : "-"}
                  </span>
                </p>
              </div>{" "}
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "35px",
                      display: "inline-block",
                      width: "30%",
                      fontSize: "15px",
                    }}
                  >
                    رفیق کا جواب موصول ہوا
                  </span>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "95%",
                      fontSize: "15px",
                      padding: "5px",
                    }}
                  >
                    <label
                      style={{
                        marginRight: "10px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Check show={printData.answerFromRafiq} />
                      <span style={{ marginRight: "5px" }}>جی ہاں</span>
                    </label>

                    <label
                      style={{
                        display: "flex",
                        marginRight: "10px",
                        alignItems: "center",
                      }}
                    >
                      <Check show={!printData.answerFromRafiq} />
                      <span style={{ marginRight: "5px" }}>جی نہیں </span>
                    </label>
                  </div>
                </p>
              </div>
            </div>{" "}
            <div style={personalInfo}>
              <div style={section}>
                {" "}
                <p>
                  <span
                    style={{
                      marginRight: "480px",
                      display: "inline-block",
                      width: "10%",
                      fontWeight: "bold",
                      fontSize: "15px",
                    }}
                  >
                    نظم اعلی
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                      width: "20%",
                      borderBottom: "2px dotted black",
                      fontSize: "15px",
                    }}
                  >
                    {printData.NazimAllaName !== null &&
                    printData.NazimAllaName !== ""
                      ? printData.NazimAllaName
                      : "-"}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default PrintMarkRafiqExNotification;
